module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ru":{"btn_submit":"Продолжить","placeholder_phone_number":"000 000 00 00"}}')
  delete Component.options._Ctor
}
